// app/providers.tsx
//
// UPDATE (2026-10-18): Optional ohneLadeOverlay — auf trauer-anzeigen.com
// (Traueranzeigen-Portal) gibt es keinen Login, der weiße „Laden...“-Schleier
// würde dort nur die Anzeige verdecken. Gesetzt in app/layout.tsx nach Host.
// Auf stillesterne.de bleibt alles unverändert.
'use client'
import { ReactNode, useEffect, useState } from 'react'
import { PermissionsProvider } from '@/context/PermissionsContext'
import { getSupabaseBrowserClient } from '@/lib/supabase'
export function Providers({ children, ohneLadeOverlay = false }: { children: ReactNode; ohneLadeOverlay?: boolean }) {
  const [initialized, setInitialized] = useState(ohneLadeOverlay)
  useEffect(() => {
    const supabase = getSupabaseBrowserClient()
    supabase.auth.getUser().finally(() => setInitialized(true))
  }, [])

  return (
    <PermissionsProvider>
      {/* ✅ Children IMMER rendern (kein Tree-Replacement mehr) */}
      {children}
      {/* Optional: Overlay solange init läuft (blockt UI, aber ersetzt den Tree nicht) */}
      {!initialized && (
        <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-white/80 dark:bg-gray-900/80">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 dark:border-gray-100 mx-auto"></div>
            <p className="mt-4 text-gray-600 dark:text-gray-300">Laden...</p>
          </div>
        </div>
      )}
    </PermissionsProvider>
  )
}
